import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { VehiclePreviewComponent } from "../../vehicles/vehicle-preview/vehicle-preview.component";
import { CommonModule } from '@angular/common';
import { DamageCase } from '../../../models/damage-case';
import { MomentDiffPipe } from '../../../pipes/moment-diff.pipe';
import { AuthenticationService } from '../../../services/auth/authentication.service';
import { AbsPipe } from "../../../pipes/abs.pipe";

@Component({
    selector: 'case-list-item',
    standalone: true,
    templateUrl: './case-list-item.component.html',
    styleUrl: './case-list-item.component.scss',
    imports: [CommonModule, VehiclePreviewComponent, MomentDiffPipe, AbsPipe]
})
export class CaseListItemComponent {
  @Input() case!: DamageCase;
  currentDate: Date = new Date();

  constructor(
      public authService: AuthenticationService,
      public router: Router) {
  }

  isCaseActive(caseId: number): boolean {
    const viewTree = this.router.createUrlTree(['case', caseId]);
    const editTree = this.router.createUrlTree(['case', caseId, 'edit']);

    return this.router.isActive(viewTree, { paths: 'exact', queryParams: 'ignored', fragment: 'ignored', matrixParams: 'ignored' })
        || this.router.isActive(editTree, { paths: 'exact', queryParams: 'ignored', fragment: 'ignored', matrixParams: 'ignored' });
  }
}
